export default class Http
  @get: (url, request, successCallback, failCallback) ->
    uncamelizedRequest = humps.decamelizeKeys(request, {
      split: /(?=[A-Z0-9])/ # for humps v1 compatibility
    })

    # Custom attribute for offline tests
    if window.offlineTest
      failCallback()
    else
      req = $.get(url, uncamelizedRequest, (data, textStatus, jqXHR) =>
        camelizedData = humps.camelizeKeys(data)

        successCallback(camelizedData, textStatus, jqXHR) if(successCallback)
      )

      if failCallback
        req.fail((jqXHR, textStatus, errorThrown) =>
          camelizedJqXHR = humps.camelizeKeys(jqXHR)

          failCallback(camelizedJqXHR, textStatus, errorThrown)
        )

  @post: (url, request, successCallback, failCallback) ->
    uncamelizedRequest = humps.decamelizeKeys(request, {
      split: /(?=[A-Z0-9])/ # for humps v1 compatibility
    })

    # Custom attribute for offline tests
    if window.offlineTest
      failCallback()
    else
      req = $.post(url, uncamelizedRequest, (data, textStatus, jqXHR) =>
        camelizedData = humps.camelizeKeys(data)

        successCallback(camelizedData, textStatus, jqXHR) if(successCallback)
      )

      if failCallback
        req.fail((jqXHR, textStatus, errorThrown) =>
          camelizedJqXHR = humps.camelizeKeys(jqXHR)

          failCallback(camelizedJqXHR, textStatus, errorThrown)
        )

  @put: (url, request, successCallback, failCallback) ->
    @post(url, _.merge({ _method: 'PUT' }, request), successCallback, failCallback)

  @patch: (url, request, successCallback, failCallback) ->
    @post(url, _.merge({ _method: 'PATCH' }, request), successCallback, failCallback)

  @delete: (url, request, successCallback, failCallback) ->
    @post(url, _.merge({ _method: 'DELETE' }, request), successCallback, failCallback)
